import { Link } from "react-router-dom";

import { PencilIcon } from "@heroicons/react/24/outline";
import { IconButton } from "../../../../../components/ui";

// Shared navigation logic for navigating to instance details
const getInstanceDetailsUrl = (id) => {
  const queryParams = new URLSearchParams(window.location.search);
  const status = queryParams.get("status") || "all";
  const listId = queryParams.get("listId") || null;
  const imageListId = queryParams.get("imageListId") || null;
  const workingListId = queryParams.get("workingListId") || null;
  const imageWorkingListId = queryParams.get("imageWorkingListId") || null;
  const listContextQuery = [
    listId ? `listId=${listId}` : null,
    imageListId ? `imageListId=${imageListId}` : null,
    workingListId ? `workingListId=${workingListId}` : null,
    imageWorkingListId ? `imageWorkingListId=${imageWorkingListId}` : null,
  ]
    .filter(Boolean)
    .join("&");

  return `${id}/details?status=${status}${listContextQuery ? `&${listContextQuery}` : ""}`;
};

const Actions = props => {
  const { getInstanceIdFromValues } = props || {};
  const id =
    typeof getInstanceIdFromValues === "function"
      ? getInstanceIdFromValues(props)
      : null;

  if (typeof id === "number") {
    const href = getInstanceDetailsUrl(id);
    return (
      <div className="user-list-actions flex text-right text-sm font-medium">
        {id && (
          <div className="grid">
            <Link to={href} title="Edit Instance">
              <IconButton variant="clean" title="Edit Instance">
                <PencilIcon
                  className={`h-4 w-4 cursor-pointer text-gray-400`}
                />
              </IconButton>
            </Link>
          </div>
        )}
      </div>
    );
  } else {
    return false;
  }
};

export default Actions;
export { getInstanceDetailsUrl };
